"use client";

import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-4 w-20 bg-muted/20 animate-pulse rounded" />
        <div className="h-4 w-24 bg-muted/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col items-start gap-3">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-black hover:text-foreground transition-colors duration-[var(--duration-fast)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    to: "#"
  }, {
    label: "Terms of Service",
    to: "#"
  }];
  return <footer id="footer" className="dark bg-background text-black w-full py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-8">
          
          <div className="md:col-span-3">
            <Link to="/HomePage" className="inline-block">
              <img src="https://calm-primate.10web.cloud/wp-content/uploads/2026/02/ChatGPT-Image-Feb-11-2026-at-07_52_49-PM-1.png" alt="West Indian Digital" className="!w-[120px] !h-[64px]" />
            </Link>
            <div className="mt-6">
              <address className="not-italic text-sm text-black/70 font-sans leading-relaxed">
                West Indian Mining Company Ltd<br />
                80 Corner Queen & St. Vincent Street<br />
                Port of Spain<br />
                Trinidad and Tobago
              </address>
            </div>
          </div>

          
          <div className="md:col-span-6">
            <MenuProvider menu_id="4">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          
          <div className="md:col-span-3 flex items-start">
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} data-index={i} newTab className="text-black hover:text-foreground transition-colors duration-[var(--duration-fast)]" aria-label={social.label}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="bg-border-strong/20 mb-6" />

        
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-sm text-black">
          <p>&copy; {currentYear} West Indian Digital. All rights reserved.</p>
          <div className="flex gap-6">
            {legalLinks.map((link, i) => <Link key={link.label} to={link.to} data-index={i} className="hover:text-black transition-colors duration-[var(--duration-fast)]">
                {link.label}
              </Link>)}
          </div>
        </div>
      </div>
    </footer>;
}